import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['scrollable', 'topIndicator', 'bottomIndicator'];
  static values = { step: { type: Number, default: 50 } };

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.refresh());
    this.resizeObserver.observe(this.scrollableTarget);
    this.refresh();
  }

  disconnect() {
    this.resizeObserver.disconnect();
  }

  scrollUp() {
    this.scrollableTarget.scrollBy({ top: -this.stepValue, behavior: 'smooth' });
  }

  scrollDown() {
    this.scrollableTarget.scrollBy({ top: this.stepValue, behavior: 'smooth' });
  }

  refresh() {
    const scrollable = this.scrollableTarget;
    const canScrollUp = scrollable.scrollTop > 0;
    const canScrollDown =
      scrollable.scrollTop + scrollable.clientHeight < scrollable.scrollHeight - 1;

    this.topIndicatorTarget.classList.toggle('d-none', !canScrollUp);
    this.bottomIndicatorTarget.classList.toggle('d-none', !canScrollDown);
  }
}
